// test1923
(1923 && 0);
